import { RefObject, useEffect, useState } from 'react';
import { goToTopOfPage, scrollToArea } from '../../../helper/helper';
import Button from '../../../components/Common/Button';
import { PageDetailsModel } from '../../../interfaces/common.interface';
import { AppDispatch } from '../../../store/store';
import { useDispatch } from 'react-redux';
import { handleUpdatePageImageService } from '../services/story.service';
import { BookModel } from '../../../interfaces/book.interface';
import { useStorageObjectUrl } from '../../../services/file.service';

interface ChooseImageFromHistoryProps {
  bookData: BookModel;
  pageIndex?: string | null;
  setShowImageHistory: (value: boolean | null) => void;
  displayBookPages: any;
  setStateData: any;
  stateData: any;
  targetRefs: RefObject<any>;
}

interface ImageHistoryItemProps {
  page: PageDetailsModel;
  imageClass: string;
  onImageSelect: (imageUrls: { imageUrl: string; imageUrlWebp: string }) => void;
}

const ImageHistoryItem = ({ page, imageClass, onImageSelect }: ImageHistoryItemProps) => {
  const { url: previousImageUrl } = useStorageObjectUrl(page?.previousImageURL);

  return (
    <div
      className={`w-48 h-48 mx-auto rounded-lg hover:border-4 hover:border-storygreen bg-gray-200 cursor-pointer ${imageClass}`}
      style={{
        backgroundImage: `url('${previousImageUrl || '/loading.gif'}')`,
        backgroundSize: 'contain'
      }}
      onClick={() => {
        onImageSelect({
          imageUrl: page.previousImageURL!,
          imageUrlWebp: page.previousImageURLWebp || page.previousImageURL!
        });
      }}
    ></div>
  );
};

const ChooseImageFromHistory = ({
                                  bookData,
                                  pageIndex,
                                  setShowImageHistory,
                                  displayBookPages,
                                  setStateData,
                                  stateData,
                                  targetRefs
                                }: ChooseImageFromHistoryProps) => {
  const [selectedImageUrl, setSelectedImageUrl] = useState({ imageUrl: '', imageUrlWebp: '' });
  const [loader, setLoader] = useState<boolean>(false);
  const dispatch: AppDispatch = useDispatch();
  useEffect(() => {
    goToTopOfPage();
    setStateData({ ...stateData, showDownloadPDF: false });
  }, []);

  const updatePageImage = async () => {
    if (!selectedImageUrl) return;

    await handleUpdatePageImageService({
      bookData,
      pageIndex,
      imageURL: selectedImageUrl.imageUrl,
      imageURLWebp: selectedImageUrl.imageUrlWebp || selectedImageUrl.imageUrl,
      displayBookPages,
      setLoader,
      setShowImageHistory,
      setStateData,
      targetRefs,
      dispatch
    });
  };

  return (
    <>
      <div className="w-full h-[25rem] overflow-auto grid grid-cols-1 md:grid-cols-3 lg:grid-cols-6 gap-4">
        {bookData?.imageLibrary?.map((page: PageDetailsModel, index: number) => {
          const isSelected = selectedImageUrl.imageUrl === page?.previousImageURL;
          const imageClass = isSelected
            ? 'border-4 border-storyblue'
            : selectedImageUrl.imageUrl
              ? 'opacity-50'
              : '';
          
          return (
            <ImageHistoryItem
              key={page?.previousImageURL || index}
              page={page}
              imageClass={imageClass}
              onImageSelect={setSelectedImageUrl}
            />
          );
        })}
      </div>

      <div className="col-span-4 text-center mt-8 w-full mx-auto  flex gap-4 justify-center flex-wrap">
        <Button
          title="Close"
          onClick={() => {
            setShowImageHistory(null);
            setStateData({ ...stateData, showDownloadPDF: true, showImageLibrary: false });
            scrollToArea(targetRefs, stateData?.pageIndex);
          }}
          className="submit-button flex justify-center gap-3 max-w-7xl bg-storyblueSecondLightText text-white font-bold rounded-2xl px-4 py-2 text-base items-center"
        />
        <Button
          title="Choose Image"
          loader={loader}
          disabled={!selectedImageUrl?.imageUrl}
          onClick={updatePageImage}
          className={`submit-button flex justify-center gap-3 max-w-7xl bg-storyblue text-white font-bold rounded-2xl px-4 py-2 text-base items-center ${selectedImageUrl?.imageUrl || selectedImageUrl?.imageUrlWebp ? '' : 'opacity-50'
          }`}
        />
      </div>
    </>
  );
};

export default ChooseImageFromHistory;
